import { Channel as UiChannel, IcalChannel as UiIcalChannel } from '@ui';

export { UiChannel as Channel, UiIcalChannel as IcalChannel };

export const ChannelLabelMap = {
  [UiChannel.Airbnb]: 'Airbnb',
  [UiChannel.AirbnbOfficial]: 'Airbnb',
  [UiChannel.Booking]: 'Booking.com',
  [UiChannel.Vrbo]: 'Vrbo',
  [UiChannel.VrboOfficial]: 'Vrbo Official',
  [UiChannel.Agoda]: 'Agoda',
  [UiChannel.Manual]: 'Manual',
  [UiChannel.Direct]: 'Direct',
} as const;
